import HttpService from "./httpService";


// Types
export interface PartialCodCharge {
    label: string;
    value: number;
    type: "fixed" | "percentage";
}

export interface PaymentMethod {
    _id: string;
    entityId: number;
    name: string;
    enabled: boolean;
    type: string;
    config?: {
        keyId?: string;
        secretKey?: string;
        upiId?: string;
        merchantId?: string;
        apiKey?: string;
        clientId?: string;
        clientSecret?: string;
        extraCharges?: number;
        value?: number;
        type?: "fixed" | "percentage";
        advanceGateway?: string;
        charges?: PartialCodCharge[];   // used by PARTIAL_COD and RAZORPAY
    };
}

export class PaymentService {

    static getPaymentDetails = () => {
        return { url: 'www.test.com', totalAmount: 1 }
    }

    static getPaymentMethods = () => {
        return HttpService.get<any>('/payment-methods');
    }

    static enableDisablePaymentMethod = (paymentMethodId: string) => {
        return HttpService.patch('/payment-methods/enable-disable', { paymentMethodId });
    }

    static updateUpiId = (upiId: string) => {
        return HttpService.post(`/payment-methods/upi`, { upiId });
    }

    static updateRazorpayConfig = (keyId: string, secretKey: string, charges: PartialCodCharge[]) => {
        return HttpService.post(`/payment-methods/razorpay`, { keyId, secretKey, charges });
    }

    static updatePhonePeConfig = (clientId: string, clientSecret: string, charges: PartialCodCharge[]) => {
        return HttpService.post(`/payment-methods/phonepe`, { clientId, clientSecret, charges });
    }

    static updateCashfreeConfig = (clientId: string, clientSecret: string, charges: PartialCodCharge[]) => {
        return HttpService.post(`/payment-methods/cashfree`, { clientId, clientSecret, charges });
    }

    static updateCodConfig = (extraCharges: number) => {
        return HttpService.post(`/payment-methods/cod`, { extraCharges });
    }

    static updateManualUpiConfig = (upiId: string) => {
        return HttpService.post(`/payment-methods/manual-upi`, { upiId });
    }

    static getOrderCharges = () => {
        return HttpService.get<{ charges: PartialCodCharge[] }>(`/payment-methods/order-charges`);
    }

    static updateOrderCharges = (charges: PartialCodCharge[]) => {
        return HttpService.put(`/payment-methods/order-charges`, { charges });
    }

    static updatePartialCodConfig = (config: { value: number; type: "fixed" | "percentage"; advanceGateway: string; charges: PartialCodCharge[] }) => {
        return HttpService.post(`/payment-methods/partial-cod`, config);
    }

}
